const {
    TEXT_NODE, COMMENT_NODE
} = Node;

const removeEmptyTags = () => {
    const dealTags = document.querySelectorAll('.deal-tags');

    dealTags.forEach((tag) => {
        const {
            childNodes
        } = tag.querySelector('.value-message__label');

        const validChildNodes = [...childNodes].filter(({
            nodeType, textContent
        }) =>
            (nodeType !== TEXT_NODE && nodeType !== COMMENT_NODE) ||
            (nodeType === TEXT_NODE && textContent.trim() !== '')
        );

        if (!validChildNodes.length) {
            tag.closest('.value-message__container').remove();
        }
    });
};

export default removeEmptyTags;
